export enum SupportedAppEnum {
  SYMPHONY = 'symphony',
  PND = 'pnd',
}
